import {Component, EventEmitter, Input, OnInit, TemplateRef} from '@angular/core';
import {CrmService} from '../../services/api/crm.service';
import {AlertService} from '../../services/notify/alert.service';
import {MemberModel} from '../../models/user.model';
import {BoardTableModel} from '../../models/tasktable.model';
import {ModalService} from '../../services/modal/modal.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-boards-accordion',
    templateUrl: './boards-accordion.component.html',
    styleUrls: ['./boards-accordion.component.scss']
})
export class BoardsAccordionComponent implements OnInit {
    @Input() public profile: MemberModel;

    boards: BoardTableModel[] = [];
    emitReloadTasks: EventEmitter<any> = new EventEmitter<any>();

    openedBoard = [];

    permissions = [
        {right: 'is_read_my_tasks'},
        {right: 'is_read_all_tasks'},
        {right: 'is_create_new_task'},
        {right: 'is_create_new_comment'},
        {right: 'is_set_property_val'},
        {right: 'is_edit_settings'},
        {right: 'is_set_self_in_task'},
        {right: 'is_set_other_in_task'},
    ];

    selectedBoard: BoardTableModel;

    constructor(
        private crmService: CrmService,
        private alertService: AlertService,
        private modalService: ModalService,
        public router: Router,
        public translate: TranslateService,
    ) {
    }

    ngOnInit(): void {
        this.emitReloadTasks.emit(true);
        this.crmService.getAllBoards({member_guid: this.profile.guid}).subscribe({
            next: data => {
                this.boards = data.boards;
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
            }
        });
    }

    openPermissions(e: MouseEvent, board: BoardTableModel, content: TemplateRef<any>): void {
        e.stopPropagation();
        e.preventDefault();

        this.selectedBoard = board;
        this.modalService.openTemplateModal(content);
    }

    redirectToBoardSettings(event: MouseEvent, board: BoardTableModel): void {
        event.stopPropagation();
        event.preventDefault();
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.SETTINGS_BP', {alias: board.alias, name: board.name}),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(res => {
            if (res) {
                void this.router.navigate(['account', 'tasks', 'options', 'statuses'], {queryParams: {alias: board.alias}});
            }
        }).catch(() => {
            return;
        });
    }
}
